import React from 'react';
import get = require("lodash/get");
import pull = require("lodash/pull");
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {observer} from "mobx-react";
import {Party, PartyNote} from "party/partyDomain";
import {ObservableMap, action} from "mobx";
import {FormProps, ClosedContentProps, lovLabel} from "core/form/formUtils";
import MdEntity from "core/metamodel/mdEntity";
import styled from "styled-components";
import StyledSelect from "core/components/fields/styledSelect";
import {FIELDDEFDISPLAYTYPE} from "core/form/form";

interface PartyNoteListProps {
  partyObject: Party;
  rootObject: Party;
  entities: ObservableMap<MdEntity>;
}

const PNF_CC_DIC = styled.div`
  font-size: 14px;
  line-height: 14px;
  min-height: 20px;
`;

@observer
export default class PartyNoteList extends React.Component<PartyNoteListProps, undefined> {


  render() {
    const {partyObject, rootObject, entities} = this.props;

    return (partyObject.notes && partyObject.notes.length) ? (
      <BlockComp  noPadding style={{display: 'flex', flexDirection: 'column'}}>

        {
          addSeparator( partyObject.notes.map((note, index) => <PartyNoteForm dataObject={note} rootObject={partyObject} key={index}
                                                                         entities={entities} entity={entities.get('PartyNote')}
                                                                         index={index} /> ), <MdDivider inset/>)
        }

      </BlockComp>
    ) : null;
  }
}




const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<PartyNote>) => (
  <PNF_CC_DIC>
    <div className="zz-grey-text zz-mb-5">{lovLabel(dataObject.noteType)}</div>
    {dataObject.content}
  </PNF_CC_DIC>
);

@createForm({
  formName: 'PartyNoteForm',
  fields: [{
    name: 'content',
    displayType: FIELDDEFDISPLAYTYPE.textArea,
    validators: ['IsRequired']
  }, {
    name: 'noteType'
  }]
}, ClosedContent)
@observer
class PartyNoteForm extends React.Component<FormProps<PartyNote, Party>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.notes, this.props.dataObject);
  };


  render() {
    const {dataObject, rootObject, entity, index, entities, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {content, noteType} = fields;

    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-6 col-sm-4 col-md-3">
            <StyledSelect {...noteType.props}/>
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...content.props} multiLine={true} rows={2}/>
            <Validate field={content} value={content.props.value}/>
          </div>
        </div>
      </div>
    );

    return (
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}





// WEBPACK FOOTER //
// ./src/party/component/partyNoteList.tsx